<template>
  <!-- 交易优势 -->
  <div class="trade-advantages">
    <h3 class="advantages-title">交易优势</h3>
    <ul class="advantages-list">
      <li class="advantage-item">
        <img src="~@/assets/imgs/icon/1.svg" alt="">
        <div>
          <p>人类交易模拟器，非第三方外挂或合约</p>
          <p><em>不必担心账户封禁风险</em></p>
        </div>
      </li>
      <li class="advantage-item">
        <img src="~@/assets/imgs/icon/2.svg" alt="">
        <div>

          <p>跳过智能路由，自定义最低费用路径</p>
          <p>交易LP费用<em>低至十万分之一</em></p>
        </div>
      </li>
      <li class="advantage-item">
        <img src="~@/assets/imgs/icon/3.svg" alt="">
        <div>
          <p>单笔任意金额均可匹配全网费率最低路径</p>
          <p><em>无需单笔大额交易</em></p>
        </div>
      </li>
      <li class="advantage-item">
        <img src="~@/assets/imgs/icon/4.svg" alt="">
        <p><em>防MEV</em>，自动配置最低滑点，降低交易磨损</p>
      </li>
      <li class="advantage-item">
        <img src="~@/assets/imgs/icon/5.svg" alt="">
        <p>让每个用户与科学家同一起跑线</p>
      </li>
      <li class="advantage-item">
        <img src="~@/assets/imgs/icon/6.svg" alt="">
        <p>如遇钱包无法打开，请用浏览器访问 <a href="//ioi.fun/">ioi.fun</a></p>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: "advantage",
    data() {
      return {
      }
    },
  }
</script>

<style lang="scss" type="text/scss" scoped>
.trade-advantages {
  padding-bottom: 20px;
  .advantages-title {
    font-size: 17px;
    font-weight: 500;
    padding: 32px 0 10px 0;
  }

  .advantages-list {
    border: 0.5px solid $border;
    border-radius: 12px;
    padding: 0 15px;

    .advantage-item {
      display: flex;
      align-items: center;
      border-bottom: 0.5px solid $border;
      padding: 16.5px 0;

      &:last-child {
        border-bottom: none;
      }

      img {
        width: 17px;
        margin-right: 8px;
      }

      p {
        font-size: 14px;
        line-height: 22px;
      }
      em {
        color: #54BC67;
      }
      a {
        color: #54BC67;
      }
    }
  }
}
</style>